var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_TW/phone_number/index.js
 ** module id = 1212
 ** module chunks = 0
 **/